import type {
  CreateTaxAddressResponse,
  EditTaxAddressResponse,
  taxAddressReq
} from "@/features/register/types";
import { fetchServer } from "@/features/utils/fetch";

export class TaxAddressApiClient {
  static async create(taxAddress: taxAddressReq, id?: string): Promise<CreateTaxAddressResponse> {
    const response = await fetchServer(
      !id
        ? "/user/tax_address/create_new"
        : `/user/tax_address/create_new?contextLegalEntityUuid=${id}`,
      {
        method: "POST",
        reloadOn401: false,
        mainRoot: false,
        body: taxAddress
      }
    );

    if (!response.ok) throw new Error("Error");

    return await response.json();
  }
  static async update(taxAddress: taxAddressReq, id?: string): Promise<EditTaxAddressResponse> {
    const response = await fetchServer(
      !id ? "/user/tax_address/edit" : `/user/tax_address/edit?contextLegalEntityUuid=${id}`,
      {
        method: "PUT",
        reloadOn401: false,
        mainRoot: false,
        body: taxAddress
      }
    );

    if (!response.ok) throw new Error("Error");

    return await response.json();
  }
}
